function slugDecisionSlot(text) {
  const slug = String(text || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 40);
  return slug || 'user_decision';
}

/**
 * Build a high-confidence user decision for the constraints ledger.
 * Closed slots retire open/fact shortlists on the next digest/patch.
 */
export function buildUserDecisionConstraint({
  question = '',
  answer = '',
  blockerTitle = '',
  sourceShapeId = '',
} = {}) {
  const value = String(answer || '').trim().replace(/\s+/g, ' ');
  if (!value) return null;
  const questionText = String(question || '').trim().replace(/\s+/g, ' ');
  const claim = questionText ? `${questionText}: ${value}` : value;
  return {
    id: `c_user_${Date.now().toString(36)}`,
    kind: 'decision',
    slot: slugDecisionSlot(blockerTitle || questionText),
    claim: claim.slice(0, 160),
    value: value.slice(0, 80),
    confidence: 'high',
    sourcePinId: '',
    sourceShapeId: String(sourceShapeId || '').trim().slice(0, 120),
    at: new Date().toISOString(),
    active: true,
  };
}

/** Close a slot with a user decision; retire open/fact/prior decisions on that slot. */
export function mergeUserDecisionConstraint(existing = [], incoming) {
  if (!incoming?.claim) return Array.isArray(existing) ? existing : [];
  const slot = String(incoming.slot || 'user_decision').toLowerCase();
  const next = [];
  for (const raw of Array.isArray(existing) ? existing : []) {
    if (!raw) continue;
    const sameSlot = String(raw.slot || '').toLowerCase() === slot;
    const retire = sameSlot && (
      raw.kind === 'open'
      || raw.kind === 'fact'
      || raw.kind === 'decision'
    );
    next.push(retire ? { ...raw, active: false } : raw);
  }
  next.unshift(incoming);
  return next;
}
